export default __webpack_public_path__ + "f302ff356c56f162dbc734be2f8e92e4.png";